const NPAReportTypes = {
	/** ***************** FETCH NPA DETAILS START *********************** */
	FETCH_NPA_REPORT_START: 'fetchNPAReportStart',
	FETCH_NPA_REPORT_SUCCESS: 'fetchNPAReportSuccess',
	FETCH_NPA_REPORT_FAILURE: 'fetchNPAReportFailure',
	FETCH_NPA_REPORT_RESPONSE_RESET_START: 'fetchNPAReportResponseResetStart',
	FETCH_NPA_REPORT_RESPONSE_CHANGED: 'fetchNPAReportResponseResetChanged',
	/** ***************** FETCH NPA DETAILS END *********************** */
};
export default NPAReportTypes;
